import { createSelector } from 'reselect';

const notifications = state => state.notifications || [];

export const changelogSelector = createSelector(notifications, (items) => items.filter(item => item.category === 'changelog'));
export const newsSelector = createSelector(notifications, (items) => items.filter(item => item.category === 'news'));
export const loginPopupSelector = createSelector(notifications, (items) => items.filter(item => item.category === 'login-popup'));